module.exports = __webpack_public_path__ + "static/logo-0d3c0ea92d44b7894e09601f1d8d6fb5.png";